window.addEventListener('load', function() {
    
    // SLICK SLIDERS
    $('.home-slider').slick({
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: 'linear',
        fade: true,
        speed: 800,
    });
    $('.products-slider-1').slick({
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 4,
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
        ]
    });
    $('.products-slider-2').slick({
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 2,
            }
          },
      ]
    });


    // SEE PASSWORD
    if (document.querySelectorAll('.see-password-wrap').length) {
      document.querySelectorAll('.see-password-wrap').forEach(element => {
        const icon = element.querySelector('.see-password');
          icon.addEventListener('click', function() {
              const input = this.closest('.see-password-wrap').querySelector('input');
              console.log(input);
              // Remove the possibility to view the password
              if (this.classList.contains('active')) {
                  this.classList.remove('active');
                  input.setAttribute('type', 'password');
              // Add the possibility to view the password
              } else {
                  this.classList.add('active');
                  input.setAttribute('type', 'text');
              }
          });
        })
    }


    // STICKY SIDEBAR
    if (document.querySelectorAll('.sticky-side').length) {
      document.querySelectorAll('.sticky-side').forEach(element => {
        new StickySidebar(element, {topSpacing: 80});
      });
    }

});